import { Component } from "@angular/core";
import { RouterLink } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { LayoutComponent } from "../../shared/layout/layout.component";
import { BreadcrumbComponent } from "../../shared/breadcrumb/breadcrumb.component";
import { StepperComponent } from "../../shared/stepper/stepper.component";
import { TitleComponent } from "../../shared/title/title.component";
import { ButtonComponent } from "../../shared/button/button.component";

@Component({
  selector: "app-register-complete",
  standalone: true,
  imports: [
    TranslatePipe,
    RouterLink,
    LayoutComponent,
    BreadcrumbComponent,
    StepperComponent,
    TitleComponent,
    ButtonComponent,
  ],
  templateUrl: "./register-complete.component.html",
  styleUrl: "./register-complete.component.css",
})
export class RegisterCompleteComponent {}
